import {Container} from 'pixi.js';
import {Signal} from '@preact/signals-core';

function jsx(
    component: FC,
    props: PropsWithChildren<{}>,
): JSX.Element {
    const node = component(props ?? {});

    return node;
}

function Fragment(props: { children: JSX.Element; }): JSX.Element {
    return props.children;
}

export { jsx, jsx as jsxs, jsx as jsxDEV, Fragment };

/**
 * Must be used when creating components.
 * Provides typings for components.
 * It is a generic type with an optional generic parameter.
 * The generic parameter specifies the props that will be passed to the function.
 * Also note that if you don't specify the 'children' parameter,
 * a default one will be added which is equal to `JSX.Element[]`
 */
export type FC<P = {}> = RubyFunctionComponent<P>;

type RubyFunctionComponent<P = {}> = (props: PropsWithChildren<P>) => JSX.Element;

export type PropsWithChildren<P> = P extends { children: any; } ? P : { children?: JSX.Element; } & P;

/**
 * Contains all the types for JSX to work properly.
 * This requires TypeScript.
 * [more info](https://www.typescriptlang.org/docs/handbook/jsx.html)
 */
export namespace JSX {
    /**
     * Represents the result of the return of the "component" functions.
     * All elements and child elements must be of this type.
     * There are exceptions only if you have specified
     * that child elements must be of a different type.
     * For example, the `For` component. But this is a rare exception.
     */
    export type Element = Container<any> | undefined | Element[] | Signal<Element>;
    export type ElementClass = null;
    export type ElementAttributesProperty = { props: {}; };
    export type ElementChildrenAttribute = {
        children: {}; // specify children name to use
    };
}